import React from "react";
import { Controller, useFieldArray } from "react-hook-form";

export default ({ indexPerm, indexSecoes, control, register }) => {
    const { fields, remove, append } = useFieldArray({
        control,
        name: `permissoes.${indexPerm}.secoes.${indexSecoes}.acoesIds`
    });
    // console.log(fields)
    return (
        <>
            {fields?.map((itemAcoes, indexAcoes) => (
             
                    <div className="form-check form-check-inline" key={indexAcoes}>
                     
                        <input type="checkbox" className="form-check-input" 
                            id={'inlineCheckbox' + indexAcoes}
                               {...register(`permissoes.${indexPerm}.secoes.${indexSecoes}.acoesIds.${indexAcoes}.value`)}
                        />                     
                        {itemAcoes.value}
                        <label className="form-check-label" htmlFor={'inlineCheckbox' + indexAcoes} >{itemAcoes.nome}</label>

                    </div>

            ))}
        </>
    )
}

